import { render, staticRenderFns } from "./ShippingClassAddressChecker.vue?vue&type=template&id=074f60ec&scoped=true&"
import script from "./ShippingClassAddressChecker.vue?vue&type=script&lang=js&"
export * from "./ShippingClassAddressChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f60ec",
  null
  
)

export default component.exports